import './Broadcast.css';

import { useRef,useEffect, useState } from "react";
import { useInterval } from '../../../utils/useInterval';
import axios from 'axios';
import { NotificationManager} from 'react-notifications';


const Broadcast = ({sessionData,userData}) => {
    const [listPesanBroadcast, setListPesanBroadcast] = useState([])
    const pesanBroadcast = useRef();
    useEffect(() => {
		axios.get(`https://backend-ta-wiyata.herokuapp.com/getall-broadcast/${sessionData['id']}/`)
			.then(function (response) {
				setListPesanBroadcast(response.data.data)
			})
			.catch((error) => {
				console.log(error)
			})
	}, [])
	useInterval(async () => {
		axios.get(`https://backend-ta-wiyata.herokuapp.com/getall-broadcast/${sessionData['id']}/`)
            .then(function (response) {
				setListPesanBroadcast(response.data.data)   
			})
            .catch((error) => {
                console.log(error)
            })
	}, 5000)
    const handleSendBroadcast = (e) => {
		e.preventDefault()
		const pesan = pesanBroadcast.current.value
		const broadcastData = {'id_sesi': sessionData['id'], 'pesan' : pesan}
		axios.post(`https://backend-ta-wiyata.herokuapp.com/create-broadcast/`, broadcastData)
			.then(response => {
				NotificationManager.success('Broadcast sent!', 'Success');
				setListPesanBroadcast(response.data.data)
				pesanBroadcast.current.value = null
				})
			.catch(error => {
				console.log(error);
		});
	}
    return (
        <div class="sesi__broadcast">
            <h3>Broadcast</h3>
            <div class="sesi__broadcast--list">
                { listPesanBroadcast.length !=0 ? 
                        listPesanBroadcast.map( broadcast => {
                            var date = new Date(broadcast.waktu_pengiriman);
                            var time = date.toLocaleString('en-GB').split(",")[1]
                            return (
                                <div class="sesi__broadcast--item">[{time}] {broadcast.pesan}</div>
                            )
                        }
                        )
                : null}
            </div>
            <div class="sesi__form-title">Input your message:</div>
            <form class="sesi__broadcast--form " onSubmit={handleSendBroadcast}>
                <textarea
                    class="wiyata-text-input"
                    type="text" 
                    name="broadcast" 
                    placeholder="Input broadcast message"
                    ref={pesanBroadcast}
                    required
                    />
                <button className='wiyata-btn'>Send</button>
            </form>
        </div>
	);
}
 
export default Broadcast;

